import {focusElement, hookToAttributeSelector} from '@wix/panda-js-utils'
import {useStyles} from '@wix/tpa-settings/react'
import {widgetDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useEnvironment} from '@wix/yoshi-flow-editor'
import React from 'react'
import stylesParams from '../../../../../../stylesParams'
import {useWidgetActions, useWidgetState} from '../../../../../hooks/state-provider'
import {
  getDayMonthText,
  getEventsForDay,
  getSelectedDate,
  getSelectedEventId,
} from '../../../../../selectors/calendar-layout'
import {getCompId} from '../../../../../selectors/component'
import {getEventById} from '../../../../../selectors/events'
import {POPUP_LAYOUT_BREAKPOINT} from '../../../../../utils/calendar'
import {PopupHeader} from '../header'
import s from './event-details.scss'
import {SideBySideEventDetailsLayout} from './side-by-side-layout'
import {VerticalEventDetailsLayout} from './vertical-layout'

export const EventDetails = () => {
  const {isMobile} = useEnvironment()
  const {get} = useStyles()
  const {closeMonthlyCalendarPopup: closeMonthlyCalendarPopupAction, closeMonthlyCalendarEvent} = useWidgetActions()

  const selectedDate = useWidgetState(getSelectedDate)
  const selectedEventId = useWidgetState(getSelectedEventId)
  const dateText = useWidgetState(state => getDayMonthText(state, selectedDate))
  const events = useWidgetState(state => getEventsForDay(state, selectedDate))
  const event = useWidgetState(state => getEventById(state, selectedEventId))
  const componentId = useWidgetState(getCompId)

  const goBackToEventList = () => {
    closeMonthlyCalendarEvent()
    setTimeout(
      () =>
        focusElement({
          selector: hookToAttributeSelector(DH.calendarEventListItem(event.id), {componentId}),
          canFocus: true,
          preventScroll: true,
        }),
      50,
    )
  }

  const closeMonthlyCalendarPopup = () => {
    closeMonthlyCalendarPopupAction()
    focusElement({
      selector: hookToAttributeSelector(DH.calendarCell(selectedDate), {componentId}),
      canFocus: true,
      preventScroll: true,
    })
  }

  return (
    <div className={s.container} data-hook={DH.calendarEventDetails}>
      <PopupHeader
        eventDetails
        text={dateText}
        onClose={closeMonthlyCalendarPopup}
        onBack={events.length > 1 ? goBackToEventList : undefined}
      />
      {!isMobile && get(stylesParams.calendarHeight) <= POPUP_LAYOUT_BREAKPOINT ? (
        <SideBySideEventDetailsLayout />
      ) : (
        <VerticalEventDetailsLayout />
      )}
    </div>
  )
}
